import Vue from 'vue';
import store from './../../store';
import ediOrderTransformer from './../../transformers/ediOrder';

const success = ({ data }, resolve) => {
  const ediOrders = ediOrderTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllEdiOrders', ediOrders);
  resolve(ediOrders);
};

const failed = () => {
};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/edi_orders')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/all.js